module.exports = __webpack_public_path__ + "static/media/POLOG_2026_Logo.f2eb767c.png";